import * as React from 'react';

interface IEmailLink {
    id?: string;
    href?: string;
    alternativeText?: string;
    className?: string;
    children?: ChildNode;
}
const EmailLink = (props: IEmailLink) => {
    const stripMailToCode = (email) => {
        if (email && typeof email === 'string' && email.indexOf('mailto:') > -1) {
            return email.replace('mailto:', '');
        }

        return email;
    };

    return (
        <span>
            <a
                href={'mailto:' + (props.href ? props.href : props.children)}
                id={props.id}
                className={props.className ? props.className + ' ' : ''}
            >
                {stripMailToCode(props.alternativeText ? props.alternativeText : props.children)}
            </a>
        </span>
    );
};

export default EmailLink;
